import { createSlice } from '@reduxjs/toolkit';
import { Product } from '../../interfaces/product';
import { getProducts } from '../ActionTypes/productActionTypes';
import { ErrorType, SerializableError } from '../../utils/errorHandling';
import { Notify } from '../../services/notificationService';

interface ProductsState {
  products: Product[];
  loading: boolean;
  error: SerializableError | null;
}

const initialState: ProductsState = {
  products: [],
  loading: false,
  error: null,
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.products = action.payload.data;
        state.loading = false;
      })
      .addCase(getProducts.rejected, (state, action) => {
        const payload = (action.payload || {}) as {
          message?: string;
          statusCode?: number;
          errorCode?: string;
        };
        const isNetwork =
          payload.errorCode === 'NETWORK_ERROR' || payload.statusCode === 0;
        state.error = {
          message:
            payload.message || 'Failed to fetch products. Please try again.',
          type: isNetwork ? ErrorType.NETWORK : ErrorType.UNKNOWN,
          statusCode: payload.statusCode,
          errorCode: payload.errorCode,
          isNetworkError: isNetwork,
        } as SerializableError;
        state.loading = false;
        Notify.error(state.error.message || 'Failed to fetch products');
      });
  },
});

export default productsSlice.reducer;
